export default __webpack_public_path__ + "static/media/supersonic.2ef326e5.webp";